'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseDropdown = require('@bibliocommons/base-dropdown');

var _baseAlerts = require('@bibliocommons/base-alerts');

var _sharedFieldErrorWrapper = require('@bibliocommons/shared-field-error-wrapper');

var _sharedFieldErrorWrapper2 = _interopRequireDefault(_sharedFieldErrorWrapper);

require('../styles/PickupBranchSelect.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PickupBranchSelect = function (_BcReactComponent) {
  _inherits(PickupBranchSelect, _BcReactComponent);

  function PickupBranchSelect(props) {
    _classCallCheck(this, PickupBranchSelect);

    var _this = _possibleConstructorReturn(this, (PickupBranchSelect.__proto__ || Object.getPrototypeOf(PickupBranchSelect)).call(this, props));

    _this.bindAll('handleSelect');

    _this.state = {
      labelledById: _lodash2.default.uniqueId('pickupBranchDropdown_')
    };
    return _this;
  }

  _createClass(PickupBranchSelect, [{
    key: 'renderSelectPickupPrompt',
    value: function renderSelectPickupPrompt() {
      if (this.props.selectedBranch === undefined && this.props.branches.size > 1) {
        return _react2.default.createElement(
          _baseAlerts.AlertInfo,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'reselect_pickup_location_prompt' })
        );
      }
      return null;
    }
  }, {
    key: 'getSelectedBranchName',
    value: function getSelectedBranchName() {
      var _this2 = this;

      var selected = this.props.branches.find(function (b) {
        return b.get('code') === _this2.props.selectedBranch;
      });
      // TODO: This needs to be determined by a setting
      return selected ? selected.get('name') : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form_label_select_a_branch' });
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return this.props.branches.map(function (branch) {
        return {
          label: branch.get('name'),
          value: branch.get('code')
        };
      });
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(value) {
      this.props.handleSelect(this.props.branches.find(function (b) {
        return b.get('code') === value;
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var label = this.props.label;
      var labelledById = this.state.labelledById;


      return _react2.default.createElement(
        'span',
        { className: 'cp-pickup-branch-select' },
        label && _react2.default.createElement(
          'span',
          { id: labelledById, className: 'col-xs-12 col-sm-4 control-label' },
          label
        ),
        _react2.default.createElement(
          'div',
          { className: 'column-input-group col-xs-12 col-sm-8' },
          this.renderSelectPickupPrompt(),
          _react2.default.createElement(_baseDropdown.Dropdown, {
            fieldErrors: this.props.fieldErrors,
            errorKey: 'physicalParams.branchId',
            selected: this.getSelectedBranchName(),
            options: this.getOptions(),
            handleSelect: this.handleSelect,
            labelledById: labelledById,
            labelLocalizedText: label,
            descriptionLocalizedText: label,
            className: 'btn-default btn-flat' })
        )
      );
    }
  }]);

  return PickupBranchSelect;
}(_baseBcReactComponent2.default);

PickupBranchSelect.propTypes = {
  label: _react.PropTypes.string,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  branches: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    name: _react.PropTypes.string,
    code: _react.PropTypes.string
  })).isRequired,
  handleSelect: _react.PropTypes.func.isRequired,
  selectedBranch: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  intl: _reactIntl.intlShape
};

PickupBranchSelect.displayName = 'PickupBranchSelect';

exports.default = (0, _reactIntl.injectIntl)((0, _sharedFieldErrorWrapper2.default)(PickupBranchSelect));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-pickup-branch-select/lib/components/PickupBranchSelect.component.js
// module id = 1498
// module chunks = 1